import React, {useState} from 'react';
import '../less/abank24.less';
import Banner from '../../../../../auxiliary-components/shared/Banner';
import {downloadA24} from '../../../../../services/urls/urls';
import Modal from "../components/Modal/templates/interactive";
import qr_code from "../img/qr_a24_download.png";
import Advantage from "../components/Advantage/templates/interactive";
import fop_block_1 from '../img/fop_block_1.png';
import fop_block_2 from '../img/fop_block_2.png';
import fop_block_3 from '../img/fop_block_3.png';
import fop_block_4 from '../img/fop_block_4.png';
import fop_block_5 from '../img/fop_block_5.png';
import fop_block_6 from '../img/fop_block_6.png';
import how_to_1 from "../img/how_to_1.png";
import how_to_2 from "../img/how_to_2.png";
import how_to_3 from "../img/how_to_3.png";
import HowToBlock from "../../../../../auxiliary-components/shared/HowToBlock";
import final_block_img from '../img/final_block_img.png';


export default function template() {
    const isMobile = this.isViewportMobile(),
        modal = <Modal title={this.l10n('ABANK_24_MODAL_TEXT')} isOpen={this.state.showModal} onClose={() => this.toggleModal()} qrCodeSrc={qr_code} />,
        page = 'abank24-page',
        btn_url = {link: downloadA24, target: '_blank' },
      howToItems = [
        { img: how_to_1, index: 'first', title: 'ABANK_24_HOW_TO_TITLE_1', text: 'ABANK_24_HOW_TO_TEXT_1' },
        { img: how_to_2, title: 'ABANK_24_HOW_TO_TITLE_2', text: 'ABANK_24_HOW_TO_TEXT_2' },
        { img: how_to_3, index: 'thirth', title: 'ABANK_24_HOW_TO_TITLE_3', text: 'ABANK_24_HOW_TO_TEXT_3' }
      ],
      carouselData = {
        "upper": [
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_1",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_2",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_3",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_4",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_5",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_6",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_7",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_8",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_9",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_10",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_11",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_12",
          "ABANK_24_RUNNING_ROW_UPPER_ITEM_13",
        ],
        "lower": [
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_1",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_2",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_3",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_4",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_5",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_6",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_7",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_8",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_9",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_10",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_11",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_12",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_13",
          "ABANK_24_RUNNING_ROW_LOWER_ITEM_14",
        ]
      }

  function getRowItem(type) {
    return (
      <div className='row-item'>
        {carouselData[type].map(el => {
          return (
            <span key={el} className='row-item-cell'>
                            {this.l10n(el)}
                        </span>
          );
        })}
      </div>
    );
  }
  getRowItem = getRowItem.bind(this);

    return (
        <div className='module-services'>
            <div className='module-abank-24'>
                <Banner
                    text={'ABANK_24_BANNER_SUBTITLE'}
                    textMob={'ABANK_24_BANNER_SUBTITLE_MOB'}
                    title={'ABANK_24_BANNER_TITLE'}
                    toggleModal={!isMobile ? () => this.toggleModal() : () => window.open(btn_url.link, btn_url.target)}
                    page={page}
                    btnText={'ABANK_24_BANNER_BUTTON_TEXT'}
                    isMobile={isMobile}
                ></Banner>
                <div className='content'>
                  <h2 className='title-block' dangerouslySetInnerHTML={{__html: isMobile ? this.l10n('ABANK_24_ADVANTAGE_TITLE_MOB') : this.l10n('ABANK_24_ADVANTAGE_TITLE')}}></h2>
                  <Advantage isMobile={isMobile} />
                </div>
                <div className='fop-block'>
                  <h2 className='fop-block-title' dangerouslySetInnerHTML={{__html: isMobile ? this.l10n('ABANK_24_ADVANTAGE_TITLE_7_MOB') : this.l10n('ABANK_24_ADVANTAGE_TITLE_7')}}></h2>
                  <div className='fop-block-wrapper'>
                    <div className='fop-block-item first'>
                      <div className='fop-block-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_FOP_TEXT_1')}}></div>
                      <img className='fop-block-item-img' src={fop_block_1} alt="fop_block_1" />
                    </div>
                    <div className='fop-block-item second'>
                      <div className='fop-block-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_FOP_TEXT_2')}}></div>
                      <img className='fop-block-item-img' src={fop_block_2} alt="fop_block_1" />
                    </div>
                    <div className='fop-block-item thirth'>
                      <img className='fop-block-item-img' src={fop_block_3} alt="fop_block_1" />
                      <div className='fop-block-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_FOP_TEXT_3')}}></div>
                    </div>
                    <div className='fop-block-item fourth'>
                      <div className='fop-block-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_FOP_TEXT_4')}}></div>
                      <img className='fop-block-item-img' src={fop_block_4} alt="fop_block_1" />
                    </div>
                    <div className='fop-block-item fifth'>
                      <div className='fop-block-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_FOP_TEXT_5')}}></div>
                      <img className='fop-block-item-img' src={fop_block_5} alt="fop_block_1" />
                    </div>
                    <div className='fop-block-item sixth'>
                      <div className='fop-block-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_FOP_TEXT_6')}}></div>
                      <img className='fop-block-item-img' src={fop_block_6} alt="fop_block_1" />
                    </div>
                  </div>
                </div>
                <div className='content second'>
                  <h2 className='title-block' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_ADVANTAGE_TITLE_8')}}></h2>
                  <HowToBlock data={howToItems} isMobile={isMobile} page={page}></HowToBlock>

                  <div className='final-block'>
                    <div className='final-block-first'>
                      <div className='left-side'>
                        <h2 className='left-side-title' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_ADVANTAGE_TITLE_9')}}></h2>
                        <button className='left-side-btn' onClick={!isMobile ? () => this.toggleModal() : () => window.open(btn_url.link, btn_url.target)}>{this.l10n('ABANK_24_BANNER_BUTTON_TEXT')}</button>
                      </div>
                      <img className='right-side' src={final_block_img} alt="final_block_img" />
                    </div>
                    <div className='final-block-second'>
                      <div className='final-block-second-text' dangerouslySetInnerHTML={{__html: this.l10n('ABANK_24_ADVANTAGE_TITLE_10')}}></div>
                      <div className='running-row-wrapper'>
                        <div className='row'>
                          {getRowItem('upper')}
                          {getRowItem('upper')}
                        </div>
                        <div className='row'>
                          {getRowItem('lower')}
                          {getRowItem('lower')}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
            </div>
          {modal}
        </div>
    );
}
